const NAME = "RECOGNITION_ANALYSIS_PAGE";

export default NAME;
